import { render, staticRenderFns } from "./jaarverslagenListFR.vue?vue&type=template&id=6fcc077a&scoped=true"
import script from "./jaarverslagenListFR.vue?vue&type=script&lang=ts"
export * from "./jaarverslagenListFR.vue?vue&type=script&lang=ts"
import style0 from "./jaarverslagenListFR.vue?vue&type=style&index=0&id=6fcc077a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc077a",
  null
  
)

export default component.exports